<wr-new-data-table
  [insideCard]="false"
  localStorageIdentifier="building-protocol-overview"
  [loadItemsFunction]="loadItems"
  [getCountFunction]="getCount"
  (lineClick)="navigateToDetail($event)"
  (newClick)="createProtocol()"
  [form]="form"
  [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="equipmentId">TGA Bauplan</label>
          <wr-tga-type-select id="equipmentId" formControlName="equipmentId"></wr-tga-type-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="protocolTypeId">Protokoll-Typ</label>
          <nb-select id="protocolTypeId" formControlName="protocolTypeId" placeholder="Alle">
            <nb-option [value]="null">Alle</nb-option>
            @for (type of protocolTypes$ | async; track type.id) {
              <nb-option [value]="type.id">{{ type.name }}</nb-option>
            }
          </nb-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template dataColumn let-item key="protocolType" exportKey="protocolType.name" display="Typ">
    <wr-protocol-type-badge [protocolType]="item.protocolType"></wr-protocol-type-badge>
  </ng-template>
  <ng-template dataColumn let-item key="buildingEquipmentName" [sortable]="false" exportKey="buildingEquipment.name" display="TGA">
    <wr-building-equipment-badge [buildingEquipment]="item.buildingEquipment"></wr-building-equipment-badge>
  </ng-template>
  <ng-template dataColumn let-item key="created" display="Erstellt">
    {{ item.created | date:'dd.MM.yyyy' }}
  </ng-template>
  <ng-template dataColumn let-item key="creator" [exportValue]="exportCreatorName" display="Erstellt von">
    <nb-user size="small"
             [name]="getCreatorName(item)"
             [picture]="getUserProfile(item.creator)">
    </nb-user>
  </ng-template>
</wr-new-data-table>
